import PropTypes from 'prop-types';

const tabType = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
};

export { tabType };
